import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import HeroSection from '../components/sections/HeroSection';
import ProductSection from '../components/sections/ProductSection';
import { products, testimonials } from '../assets/data/products';
import {
  FaGem, FaCrown, FaRing, FaShieldAlt,
  FaTruck, FaCertificate, FaStar, FaQuoteLeft,
  FaInstagram, FaPlay, FaArrowUp
} from 'react-icons/fa';
import { useTheme } from '../context/ThemeContext';
import { Link } from 'react-router-dom';
import api from '../api/Api';

const Home = () => {
  const { isDarkMode } = useTheme();
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [product, setProducts] = useState([]);


  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Filter products by category/collection

  const trendingProducts = products.filter(p => p.trending);

  useEffect(() => {
    api.get('/product/list', { params: { per_page: 10 } })
      .then(({ data }) => {
        console.log('Products API Response:', data);
        setProducts(data?.data?.data);
      })
      .catch((error) => {
        console.error('Error fetching products:', error);
      });
  }, []);
  console.log('Products state:', product);

  const goldProducts = products.filter(p => p.category === 'Gold');
  const diamondProducts = products.filter(p => p.category === 'Diamond');
  const bridalProducts = products.filter(p => p.collection === 'Bridal');

  const collections = [
    {
      id: 1,
      name: 'Gold Collection',
      description: 'Timeless elegance in pure gold',
      image: 'https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?w=600',
      icon: <FaCrown />,
      link: '/category/gold'
    },
    {
      id: 2,
      name: 'Diamond Collection',
      description: 'Brilliance that captivates',
      image: 'https://images.unsplash.com/photo-1602173574767-37ac01994b2a?w=600',
      icon: <FaGem />,
      link: '/category/diamond'
    },
    {
      id: 3,
      name: 'Bridal Collection',
      description: 'Make your special day unforgettable',
      image: 'https://images.unsplash.com/photo-1506630448388-4e683c67ddb0?w=600',
      icon: <FaRing />,
      link: '/collections/bridal'
    }
  ];

  const instagramPosts = [
    'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=300',
    'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=300',
    'https://images.unsplash.com/photo-1573408301185-9146fe634ad0?w=300',
    'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=300',
    'https://images.unsplash.com/photo-1602751584552-8ba73aad10e1?w=300',
    'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=300'
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <HeroSection />

      {/* Collections Showcase */}
      <section className="section-padding" style={{
        background: isDarkMode ? 'var(--bg-secondary)' : 'var(--bg-secondary)'
      }}>
        <div className="container">
          <motion.div
            className="text-center mb-5"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}>
            <h2 className="display-5 mb-3" style={{
              fontFamily: 'var(--font-secondary)',
              fontWeight: '700'
            }}>
              Our Premium Collections
            </h2>
            <p className="lead text-muted">
              Discover exquisite jewellery crafted with precision and passion
            </p>
          </motion.div>

          <div className="row g-4">
            {collections.map((collection, index) => (
              <div key={collection.id} className="col-md-4">
                <motion.div
                  className="position-relative overflow-hidden rounded-3 h-100"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.2 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.02 }}
                  style={{ cursor: 'pointer' }}>
                  <Link to={collection.link} className="text-decoration-none">
                    <div style={{ height: '400px', position: 'relative' }}>
                      <img
                        src={collection.image}
                        alt={collection.name}
                        className="w-100 h-100 object-fit-cover"
                      />
                      <div className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                          background: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.7) 100%)'
                        }} />
                      <div className="position-absolute bottom-0 start-0 p-4 text-white">
                        <div className="mb-3" style={{ fontSize: '40px', color: 'var(--primary-gold)' }}>
                          {collection.icon}
                        </div>
                        <h4 className="mb-2">{collection.name}</h4>
                        <p className="mb-0 opacity-75">{collection.description}</p>
                      </div>
                    </div>
                  </Link>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trending Products */}
      <ProductSection
        title="Trending Now"
        subtitle="Most Popular"
        products={product}
        showFilter={false}
        columns={4}
      />

      {/* Gold Collection */}
      <ProductSection
        title="Gold Collection"
        subtitle="Pure Elegance"
        products={product}
        showFilter={false}
        columns={4}
      />

      {/* Special Offer Banner */}
      <section className="py-5" style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)'
      }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}>
                <h3 className="text-white mb-3">Limited Time Offer</h3>
                <h2 className="display-4 gold-text mb-3">Get 20% Off On Diamond Jewellery</h2>
                <p className="text-white-50 mb-4">
                  Exclusive offer on our premium diamond collection. Limited stock available!
                </p>
                <Link to="/category/diamond" className="btn btn-luxury btn-lg">
                  Shop Now
                </Link>
              </motion.div>
            </div>
            <div className="col-lg-4 text-end">
              <motion.div
                className="display-1 gold-text"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                style={{ fontWeight: '900' }}>
                20%
                <span className="d-block h3">OFF</span>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Diamond Collection */}
      <ProductSection
        title="Diamond Dreams"
        subtitle="Luxury Redefined"
        products={diamondProducts}
        showFilter={false}
        columns={4}
      />

      {/* Testimonials */}
      <section className="section-padding" style={{
        background: isDarkMode ? 'var(--bg-secondary)' : 'var(--bg-secondary)'
      }}>
        <div className="container">
          <motion.div
            className="text-center mb-5"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}>
            <h2 className="display-5 mb-3" style={{
              fontFamily: 'var(--font-secondary)',
              fontWeight: '700'
            }}>
              What Our Customers Say
            </h2>
          </motion.div>

          <div className="row g-4">
            {testimonials.map((testimonial, index) => (
              <div key={testimonial.id} className="col-md-4">
                <motion.div
                  className="card h-100 border-0"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  viewport={{ once: true }}
                  style={{
                    background: isDarkMode ? 'var(--bg-primary)' : 'white',
                    boxShadow: 'var(--shadow-md)',
                    borderRadius: '15px'
                  }}>
                  <div className="card-body p-4">
                    <FaQuoteLeft className="mb-3" style={{
                      fontSize: '30px',
                      color: 'var(--primary-gold)',
                      opacity: 0.3
                    }} />
                    <div className="mb-3">
                      {[...Array(5)].map((_, i) => (
                        <FaStar key={i} style={{
                          color: 'var(--primary-gold)',
                          fontSize: '16px'
                        }} />
                      ))}
                    </div>
                    <p className="mb-4" style={{ fontStyle: 'italic' }}>
                      "{testimonial.comment}"
                    </p>
                    <div className="d-flex align-items-center">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="rounded-circle me-3"
                        style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                      />
                      <div>
                        <h6 className="mb-0">{testimonial.name}</h6>
                        <small className="text-muted">Verified Customer</small>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Instagram Gallery */}
      <section className="section-padding">
        <div className="container">
          <motion.div
            className="text-center mb-5"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}>
            <h2 className="display-5 mb-3" style={{
              fontFamily: 'var(--font-secondary)',
              fontWeight: '700'
            }}>
              Follow Us On Instagram
            </h2>
            <p className="lead text-muted">@bharatgoldjewellery</p>
          </motion.div>

          <div className="row g-3">
            {instagramPosts.map((post, index) => (
              <div key={index} className="col-6 col-md-4 col-lg-2">
                <motion.div
                  className="position-relative overflow-hidden rounded-3"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: index * 0.05 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.05 }}
                  style={{ cursor: 'pointer', height: '200px' }}>
                  <img
                    src={post}
                    alt={`Instagram post ${index + 1}`}
                    className="w-100 h-100 object-fit-cover"
                  />
                  <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center opacity-0"
                    style={{
                      background: 'rgba(0,0,0,0.7)',
                      transition: 'opacity 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
                    onMouseLeave={(e) => e.currentTarget.style.opacity = 0}>
                    <FaInstagram style={{
                      fontSize: '40px',
                      color: 'white'
                    }} />
                  </div>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Back to Top Button */}
      <motion.button
        className="back-to-top"
        onClick={scrollToTop}
        initial={{ opacity: 0 }}
        animate={{ opacity: showBackToTop ? 1 : 0 }}
        style={{
          position: 'fixed',
          bottom: '30px',
          right: '30px',
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          background: 'var(--gradient-gold)',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          zIndex: 999,
          visibility: showBackToTop ? 'visible' : 'hidden',
          boxShadow: 'var(--shadow-lg)'
        }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}>
        <FaArrowUp style={{ color: '#1a1a1a', fontSize: '20px' }} />
      </motion.button>
    </div>
  );
};

export default Home;